(function () {
  const LOADING_HTML =
    '<div class="mc2-qc__loading"><span class="loading__spinner" aria-hidden="true"></span><p>Loading…</p></div>';

  function getModal() {
    return document.querySelector('mc2-quick-checkout-modal');
  }

  function productHandleFromUrl(url) {
    try {
      const path = new URL(url, window.location.origin).pathname;
      const match = path.match(/\/products\/([^/?#]+)/);
      return match ? decodeURIComponent(match[1]) : null;
    } catch (error) {
      return null;
    }
  }

  function formatMoney(cents) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents, window.Shopify.money_format || '{{amount}}');
    }
    return '₹' + (Number(cents || 0) / 100).toFixed(2);
  }

  function escapeHtml(str) {
    return String(str || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function optionNameAt(product, index) {
    const opt = product.options[index];
    if (!opt) return 'Variant';
    if (typeof opt === 'string') return opt;
    if (typeof opt === 'object' && opt.name) return opt.name;
    return 'Variant';
  }

  function shouldShowVariantPicker(product) {
    if (!product.variants || product.variants.length <= 1) return false;
    if (product.variants.length === 1 && product.variants[0].title === 'Default Title') return false;
    const names = product.options.map((_, i) => optionNameAt(product, i));
    if (names.length === 1 && names[0] === 'Title') {
      const values = new Set(product.variants.map((v) => v.option1));
      return values.size > 1;
    }
    return product.options.length > 0;
  }

  function getVariantImage(product, variant) {
    if (variant.featured_image && variant.featured_image.src) return variant.featured_image.src;
    if (variant.featured_image && typeof variant.featured_image === 'string') return variant.featured_image;
    if (product.featured_image) return product.featured_image;
    if (product.images && product.images.length) return product.images[0];
    return '';
  }

  function findVariant(product, selectedOptions) {
    return product.variants.find((variant) => {
      return product.options.every((_, index) => {
        const key = 'option' + (index + 1);
        return variant[key] === selectedOptions[index];
      });
    });
  }

  function getOptionValues(product, optionIndex, selectedOptions) {
    const values = new Set();
    product.variants.forEach((variant) => {
      const matches = product.options.every((_, i) => {
        if (i === optionIndex) return true;
        const key = 'option' + (i + 1);
        return variant[key] === selectedOptions[i];
      });
      if (matches) {
        const key = 'option' + (optionIndex + 1);
        if (variant[key]) values.add(variant[key]);
      }
    });
    return Array.from(values);
  }

  function buyNowUrl(variantId, qty) {
    return '/cart/' + variantId + ':' + Math.max(1, Number(qty) || 1);
  }

  function renderModal(product) {
    const firstAvailable = product.variants.find((v) => v.available) || product.variants[0];
    const selectedOptions = product.options.map((_, i) => firstAvailable['option' + (i + 1)] || '');
    const imageSrc = getVariantImage(product, firstAvailable);
    const showVariants = shouldShowVariantPicker(product);

    let optionsHtml = '';
    if (showVariants) {
      optionsHtml = product.options
        .map((_, optionIndex) => {
          const rawLabel = optionNameAt(product, optionIndex);
          const label = rawLabel === 'Title' ? 'Variant' : rawLabel;

          const values = getOptionValues(product, optionIndex, selectedOptions);
          if (!values.length) return '';

          const options = values
            .map((value) => {
              const selected = value === selectedOptions[optionIndex] ? ' selected' : '';
              return `<option value="${escapeHtml(value)}"${selected}>${escapeHtml(value)}</option>`;
            })
            .join('');

          return `
            <div class="mc2-qc__field">
              <label class="mc2-qc__label" for="mc2-qc-opt-${optionIndex}">${escapeHtml(label)}</label>
              <select class="mc2-qc__select" id="mc2-qc-opt-${optionIndex}" data-mc2-qc-option="${optionIndex}">
                ${options}
              </select>
            </div>`;
        })
        .join('');
    }

    return `
      <div class="mc2-qc" data-mc2-qc-root>
        <div class="mc2-qc__body">
          <div class="mc2-qc__top">
            <div class="mc2-qc__media">
              ${
                imageSrc
                  ? `<img src="${escapeHtml(imageSrc)}" alt="${escapeHtml(product.title)}" width="120" height="120" loading="lazy" data-mc2-qc-image>`
                  : `<div class="mc2-qc__media-placeholder"></div>`
              }
            </div>
            <div class="mc2-qc__summary">
              <h2 class="mc2-qc__title">${escapeHtml(product.title)}</h2>
              <p class="mc2-qc__price" data-mc2-qc-price>${formatMoney(firstAvailable.price)}</p>
            </div>
          </div>
          ${optionsHtml}
          <div class="mc2-qc__field mc2-qc__field--qty">
            <label class="mc2-qc__label" for="mc2-qc-qty">Quantity</label>
            <div class="mc2-qc__qty">
              <button type="button" class="mc2-qc__qty-btn" data-mc2-qc-qty-step="-1" aria-label="Decrease quantity">−</button>
              <input id="mc2-qc-qty" class="mc2-qc__qty-input" type="number" inputmode="numeric" pattern="[0-9]*" min="1" value="1" data-mc2-qc-qty>
              <button type="button" class="mc2-qc__qty-btn" data-mc2-qc-qty-step="1" aria-label="Increase quantity">+</button>
            </div>
          </div>
        </div>
        <div class="mc2-qc__actions">
          <a
            href="${buyNowUrl(firstAvailable.id, 1)}"
            class="mc2-qc__btn mc2-qc__btn--buy"
            data-mc2-qc-buy
            ${firstAvailable.available ? '' : 'aria-disabled="true" tabindex="-1"'}
          >
            ${firstAvailable.available ? 'Buy now' : 'Sold out'}
          </a>
        </div>
        <input type="hidden" data-mc2-qc-variant-id value="${firstAvailable.id}">
      </div>`;
  }

  function bindModalEvents(modal, product) {
    const root = modal.modalContent.querySelector('[data-mc2-qc-root]');
    if (!root) return;

    const first = product.variants.find((v) => v.available) || product.variants[0];
    const state = {
      selectedOptions: product.options.map((_, i) => first['option' + (i + 1)] || ''),
    };

    const els = {
      image: root.querySelector('[data-mc2-qc-image]'),
      price: root.querySelector('[data-mc2-qc-price]'),
      variantId: root.querySelector('[data-mc2-qc-variant-id]'),
      qty: root.querySelector('[data-mc2-qc-qty]'),
      buyBtn: root.querySelector('[data-mc2-qc-buy]'),
    };

    function currentVariant() {
      return findVariant(product, state.selectedOptions) || product.variants[0];
    }

    function updateBuyUrl() {
      const variant = currentVariant();
      if (!variant || !els.buyBtn) return;

      els.variantId.value = variant.id;
      els.price.textContent = formatMoney(variant.price);

      const imgSrc = getVariantImage(product, variant);
      if (els.image && imgSrc) els.image.src = imgSrc;

      const qty = els.qty?.value || 1;
      els.buyBtn.href = buyNowUrl(variant.id, qty);

      if (variant.available) {
        els.buyBtn.textContent = 'Buy now';
        els.buyBtn.removeAttribute('aria-disabled');
        els.buyBtn.removeAttribute('tabindex');
      } else {
        els.buyBtn.textContent = 'Sold out';
        els.buyBtn.setAttribute('aria-disabled', 'true');
        els.buyBtn.setAttribute('tabindex', '-1');
      }
    }

    root.querySelectorAll('[data-mc2-qc-option]').forEach((select) => {
      select.addEventListener('change', () => {
        state.selectedOptions[Number(select.dataset.mc2QcOption)] = select.value;
        product.options.forEach((_, optionIndex) => {
          if (Number(select.dataset.mc2QcOption) === optionIndex) return;
          const selectEl = root.querySelector(`[data-mc2-qc-option="${optionIndex}"]`);
          if (!selectEl) return;
          const values = getOptionValues(product, optionIndex, state.selectedOptions);
          const current = selectEl.value;
          selectEl.innerHTML = values
            .map((value) => {
              const selected = value === state.selectedOptions[optionIndex] ? ' selected' : '';
              return `<option value="${escapeHtml(value)}"${selected}>${escapeHtml(value)}</option>`;
            })
            .join('');
          if (!values.includes(current) && values.length) {
            selectEl.value = values[0];
            state.selectedOptions[optionIndex] = values[0];
          }
        });
        updateBuyUrl();
      });
    });

    root.querySelectorAll('[data-mc2-qc-qty-step]').forEach((btn) => {
      btn.addEventListener('click', () => {
        const step = Number(btn.dataset.mc2QcQtyStep);
        const min = Number(els.qty.min || 1);
        els.qty.value = Math.max(min, Number(els.qty.value || 1) + step);
        updateBuyUrl();
      });
    });

    els.qty?.addEventListener('change', updateBuyUrl);

    els.buyBtn?.addEventListener('click', (event) => {
      const variant = currentVariant();
      if (!variant || !variant.available) {
        event.preventDefault();
      }
    });
  }

  function defineModal() {
    if (customElements.get('mc2-quick-checkout-modal')) return;
    if (typeof ModalDialog === 'undefined') {
      console.error('[mc2-quick-checkout] ModalDialog not found — ensure global.js loads first.');
      return;
    }

    customElements.define(
      'mc2-quick-checkout-modal',
      class Mc2QuickCheckoutModal extends ModalDialog {
        constructor() {
          super();
          this.modalContent = this.querySelector('#Mc2QuickCheckoutInfo');
        }

        connectedCallback() {
          if (this.moved) return;
          this.moved = true;
          document.body.appendChild(this);
        }

        hide(preventFocus = false) {
          const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
          if (cartNotification) cartNotification.setActiveElement(this.openedBy);
          if (this.modalContent) this.modalContent.innerHTML = '';
          if (preventFocus) this.openedBy = null;
          super.hide();
        }

        show(opener) {
          const productUrl = opener.getAttribute('data-product-url') || opener.getAttribute('href');
          const handle = productHandleFromUrl(productUrl);
          if (!handle || !this.modalContent) return;

          opener.setAttribute('aria-disabled', 'true');
          opener.classList.add('loading');

          this.modalContent.innerHTML = LOADING_HTML;
          super.show(opener);

          fetch('/products/' + handle + '.js')
            .then((response) => {
              if (!response.ok) throw new Error('Product not found');
              return response.json();
            })
            .then((product) => {
              this.modalContent.innerHTML = renderModal(product);
              bindModalEvents(this, product);
            })
            .catch(() => {
              window.location.href = productUrl;
            })
            .finally(() => {
              opener.removeAttribute('aria-disabled');
              opener.classList.remove('loading');
            });
        }
      }
    );
  }

  function bindClicks() {
    if (document.body.dataset.mc2QuickCheckoutBound) return;
    document.body.dataset.mc2QuickCheckoutBound = '1';

    document.addEventListener(
      'click',
      (event) => {
        const trigger = event.target.closest('[data-mc2-quick-checkout]');
        if (!trigger || trigger.hasAttribute('disabled') || trigger.getAttribute('aria-disabled') === 'true') return;

        event.preventDefault();
        event.stopPropagation();

        const modal = getModal();
        if (!modal || typeof modal.show !== 'function') {
          const fallbackUrl = trigger.getAttribute('data-product-url') || trigger.getAttribute('href');
          if (fallbackUrl) window.location.href = fallbackUrl;
          return;
        }

        modal.show(trigger);
      },
      true
    );
  }

  function init() {
    if (!getModal()) return;
    defineModal();
    bindClicks();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
